import { c as _c } from "react/compiler-runtime";
// The one icon button: a round, borderless glyph button for page actions (PageHead `actions`). `label` is its
// accessible name and tooltip. Styles: book.css `.icon-button`.
import type { ButtonHTMLAttributes } from "react";
type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  label: string;
  t?: string;
};
export function IconButton(t0) {
  const $ = _c(14);
  let children;
  let className;
  let label;
  let rest;
  let t;
  if ($[0] !== t0) {
    ({
      label,
      t,
      children,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = label;
    $[4] = rest;
    $[5] = t;
  } else {
    children = $[1];
    className = $[2];
    label = $[3];
    rest = $[4];
    t = $[5];
  }
  let t1;
  if ($[6] !== className) {
    t1 = ["icon-button", className].filter(Boolean);
    $[6] = className;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const t2 = t1.join(" ");
  let t3;
  if ($[8] !== children || $[9] !== label || $[10] !== rest || $[11] !== t || $[12] !== t2) {
    t3 = <button type="button" className={t2} data-t={t} aria-label={label} title={label} {...rest}>{children}</button>;
    $[8] = children;
    $[9] = label;
    $[10] = rest;
    $[11] = t;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}